import React, { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import SearchModal from '../components/ModalSearch';
import Notifications from '../components/DropdownNotifications';
import Help from '../components/DropdownHelp';
import UserMenu from '../components/DropdownProfile';
import ThemeToggle from '../components/ThemeToggle';
import { close, menu } from '../images/landingPage';

function Header({ sidebarOpen, setSidebarOpen, variant = 'default', onStockSelect }) {
  const [searchModalOpen, setSearchModalOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const modalRef = useRef(null);
  const mobileMenuRef = useRef(null);
  const location = useLocation();

  const shouldShowSearch = () => {
    return location.pathname === '/dashboard' || location.pathname === '/dashboard/analyse';
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setSearchModalOpen(false);
      }
      if (mobileMenuRef.current && !mobileMenuRef.current.contains(event.target)) {
        setMobileMenuOpen(false);
      }
    }

    if (searchModalOpen || mobileMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [searchModalOpen, mobileMenuOpen]);

  const handleStockSelect = (stock) => {
    if (typeof onStockSelect === 'function') {
      onStockSelect(stock);
    } else {
      console.error('onStockSelect is not a function');
    }
  };

  useEffect(() => {
    document.documentElement.classList.add('dark');
    localStorage.setItem('theme', 'dark');
  }, []);

  const mobileMenuItems = [
    { id: 'notifications', title: 'Notifications', component: <Notifications minimal={true} align="right" /> },
    { id: 'help', title: 'Help', component: <Help minimal={true} align="right" /> },
    { id: 'theme', title: 'Theme', component: <ThemeToggle minimal={true} /> }
  ];

  return (
    <header className={`sticky top-0 before:absolute before:inset-0 before:backdrop-blur-md max-lg:before:bg-gray-800/90 dark:max-lg:before:bg-gray-800/90 before:-z-10 z-30`}>
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="flex items-center h-16">
          {/* Burger Menu Button */}
          
          {/* Search section */}
          {shouldShowSearch() && (
            <div className="flex-1 min-w-0 lg:flex-none mx-4 max-w-[150px] sm:max-w-none">
              <div
                className="flex items-center space-x-2 cursor-pointer px-3 sm:px-4 py-2 rounded-md border border-gray-300 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-800 w-full lg:w-auto"
                onClick={(e) => {
                  e.stopPropagation();
                  setSearchModalOpen(true);
                }}
              >
                <svg className="shrink-0 fill-current text-gray-500/80 dark:text-gray-400/80" width={16} height={16} viewBox="0 0 16 16">
                  <path d="M7 14c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7ZM7 2C4.243 2 2 4.243 2 7s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5Z" />
                  <path d="m13.314 11.9 2.393 2.393a.999.999 0 1 1-1.414 1.414L11.9 13.314a8.019 8.019 0 0 0 1.414-1.414Z" />
                </svg>
                <span className="text-sm text-gray-600 dark:text-gray-400 truncate">Søg på aktier...</span>
              </div>
            </div>
          )}

          {/* Right section */}
          <div className={`flex items-center ml-auto ${shouldShowSearch() ? '' : 'flex-1 justify-end'}`}>
            <div className="flex items-center space-x-3">
              <UserMenu align="right" minimal={false} />
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      <div
        className={`${
          mobileMenuOpen ? "flex" : "hidden"
        } fixed inset-0 bg-black/95 backdrop-blur-md z-[900] lg:hidden`}
      >
        <div className="w-full h-full flex flex-col justify-center items-center">
          <ul className="list-none flex flex-col justify-center items-center w-full h-full">
            {mobileMenuItems.map((item) => (
              <li
                key={item.id}
                className="font-poppins font-semibold cursor-pointer text-[32px] mb-10 text-dimWhite hover:text-white transition-colors duration-300"
              >
                <div className="flex items-center justify-center">
                  {item.component}
                  <span className="ml-3">{item.title}</span>
                </div>
              </li>
            ))}
            <li className="font-poppins font-semibold cursor-pointer text-[32px] mb-10 text-dimWhite hover:text-white transition-colors duration-300">
              <UserMenu align="right" minimal={true} />
            </li>
          </ul>
        </div>
      </div>

      {/* Search Modal */}
      <div ref={modalRef}>
        <SearchModal
          id="search-modal"
          searchId="search"
          modalOpen={searchModalOpen}
          setModalOpen={setSearchModalOpen}
          onStockSelect={handleStockSelect}
        />
      </div>
    </header>
  );
}

export default Header;